import { en, cs } from 'vuetify/lib/locale'
import customcs from './cs.json'
import customen from './en.json'

export const messages = { cs: { ...customcs, $vuetify: cs }, en: { ...customen, $vuetify: en } };
export const list = [
    {
        code: 'en',
        flag: 'us',
        label: 'English'
    },
    {
        code: 'cs',
        flag: 'cz',
        label: 'Česky'
    }
];

export const dateTimeFormats = {
    'en': {
        short: {
          year: 'numeric',
          month: 'short',
          day: 'numeric'
        },
        long: {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          //weekday: 'long',
          hour: 'numeric',
          minute: 'numeric'
        }
    },
    'cs': {
        short: {
          year: 'numeric',
          month: 'numeric',
          day: 'numeric'
        },
        long: {
          year: 'numeric',
          month: 'numeric',
          day: 'numeric',
          //weekday: 'long',
          hour: 'numeric',
          minute: 'numeric'
        }
    }
}


export const getLang = () => navigator?.languages?.map(e => e.split('-')[0]).find(e=> !!messages[e]) || 'en'
